import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import GetTheComapnyBoywithpinacular from "../../assets/images/boywithpinacular.png";
import { ReactComponent as Image } from "../../assets/images/getthecompany.svg";
import { useSelector } from "react-redux";
import { DESIGNATION_MAX_LENGTH, validateDesignation } from "../../utils/designation";

export const GetTheCompany = ({
  des,
  button,
  fromBanner,
  company,
  company_id,
  SubscriptionActive,
  handlePurchased,
  handleGetCompany,
  createWorldBoxOrder,
  isContinue,
  secondayListedHandler,
  acknowledgement,
  formData,
  setFormData,
}) => {
  const navigate = useNavigate();
  const { userInfo, isLoggedIn, token } = useSelector((state) => state.auth);
  const { id } = useParams();

  const [isAcknowledged, setIsAcknowledged] = useState(false);

  useEffect(() => {
    const formObject = formData || {};
    const isAnyFieldFilled = Object.values(formObject).some((value) => value.trim());

    if (isAnyFieldFilled && !isAcknowledged) {
      setIsAcknowledged(true);
    }
  }, [formData, isAcknowledged]);

  const handleNavigate = () => {
    window.scrollTo(0, 0);
    navigate("/plans", {
      state: { company_id: id },
    });

  };


  const designationError = isAcknowledged && (formData.designation || '').trim() !== ''
    ? validateDesignation(formData.designation)
    : null;

  const isFormIncomplete = isAcknowledged && (
    !formData.name || !formData.designation || !formData.email ||
    formData.name.trim() === '' || formData.designation.trim() === '' || formData.email.trim() === '' ||
    Boolean(designationError)
  );

  const handleAcknowledgementChange = (e) => {
    const isChecked = e.target.checked;
    setIsAcknowledged(isChecked);

    // If the checkbox is being unchecked, clear the form data
    if (!isChecked) {
      setFormData({
        name: '',
        designation: '',
        email: '',
        contactNumber: '',
      });
    }
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleClick = (e) => {
    if (isContinue) {
      secondayListedHandler();
    } else {
      SubscriptionActive ? handlePurchased() : company?.claimed
        ? handleGetCompany()
        : createWorldBoxOrder(formData)
    }
  }
  return (
    <div className="text-center flex flex-col items-center">
      {fromBanner ? (
        <img src={GetTheComapnyBoywithpinacular} style={{ width: '100px', padding: '10px' }} alt="GetTheBusiness" />
      ) : (
        <Image />
      )}
      <h3 className="text-secondarytwo text-left text-f20 font-semibold">
        Get The Business
      </h3>
      <p className="text-secondary pt-2 pb-4 w-80 text-f14">{des}</p>
      {
        acknowledgement && (
          <>
            <div className="flex">
              <input
                type="checkbox"
                checked={isAcknowledged}
                onChange={handleAcknowledgementChange}
                id="acknowledgementCheckbox"
                className="m-3"
              />
              <label className="text-secondary pt-2 pb-4 w-80 text-f12" htmlFor="acknowledgementCheckbox">Can we contact a business representative using your provided details to create a detailed report?</label>
            </div>
            {isAcknowledged && (
              <div className="form">
                <input
                  type="text"
                  className="text-secondary pt-2 pb-4 w-80 text-f14"
                  value={formData.name}
                  onChange={handleFormChange}
                  name="name"
                  placeholder="Name"
                /><br />
                <input
                  type="text"
                  className="text-secondary pt-2 pb-4 w-80 text-f14"
                  value={formData.designation}
                  onChange={handleFormChange}
                  name="designation"
                  maxLength={DESIGNATION_MAX_LENGTH}
                  placeholder="Designation"
                /><br />
                {designationError && (
                  <p className="text-red-500 text-sm text-left">{designationError}</p>
                )}
                <input
                  type="email"
                  className="text-secondary pt-2 pb-4 w-80 text-f14"
                  value={formData.email}
                  onChange={handleFormChange}
                  name="email"
                  placeholder="Email Address"
                /><br />
                <input
                  type="tel"
                  className="text-secondary pt-2 pb-4 w-80 text-f14"
                  value={formData.contactNumber}
                  onChange={handleFormChange}
                  name="contactNumber"
                  placeholder="Contact Number (optional)"
                /><br />
              </div>
            )}
          </>
        )
      }
      <hr />
      <button
        onClick={handleClick}
        className={`bg-primary px-4 py-2 text-white text-f14 rounded w-full ${isFormIncomplete ? 'opacity-50 cursor-not-allowed' : ''}`}
        disabled={isFormIncomplete}
      >
        {button}
      </button>
      <div className="flex justify-between text-secondary pt-4 items-center"></div>
    </div>
  );
};
